<template>
  <transition name="fade">
    <aside v-if="isShow" class="top">
      <a href="#top">
        <img src="../assets/image/top.png"/>
      </a>
    </aside>
  </transition>
</template>
<script>
export default {
  name: 'Top',
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      if (document.documentElement.scrollTop > 1500) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    })
  }
}
</script>
<style lang="less" scoped>
.top {
  background: #ccc;
  position: fixed;
  bottom: 340px;
  right: 10px;
  height: 56px;
  width: 56px;
  border-radius: 50%;
  text-align: center;
  a {
    cursor: pointer;
    display: inline-block;
    height: 100%;
    width: 100%;
    img {
      height: 56px;
      width: 56px;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
